import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgBurger = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 22 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M.168 1.657h20.978m-20.978 7h20.978m-20.978 7h20.978"
      stroke="#fff"
    />
  </svg>
);
const Memo = memo(SvgBurger);
export default Memo;
